export default {

    //成功码
    SUCCESS_CODE : 0,
    localLangage:'local-langage'//本地化语言 
   
   }

//    export  const  SUCCESS_CODE = 0